import React, { Fragment } from 'react'
import { WithoutIconProps } from './interfaces'

export default function WithoutIcon({ title, description }: WithoutIconProps) {
  return (
    <Fragment>
      <p>
        {<b>{title}</b>} – {description}.
      </p>
    </Fragment>
  )
}
